import { render } from "./ClientShellView.vue?vue&type=template&id=6166f4f5&scoped=true"
import script from "./ClientShellView.vue?vue&type=script&lang=js"
export * from "./ClientShellView.vue?vue&type=script&lang=js"

import "./ClientShellView.vue?vue&type=style&index=0&id=6166f4f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166f4f5"]])

export default __exports__